import React from "react";
import { Box } from "@mui/material";
import { BRAND, DOSSIER_STATUS, hexToRgba } from "../lightTheme";

/**
 * Unified status chip for Light mode.
 * @param {string} code - status code to look up
 * @param {object} statusMap - status config object (default: DOSSIER_STATUS)
 * @param {"filled"|"tinted"} variant - "filled" uses cfg.bg, "tinted" uses hexToRgba(cfg.color, 0.18)
 * @param {object} style - additional inline styles
 * @param {string} className - optional CSS class (overrides default inline styles when provided)
 */
export default function LightStatusChip({ code, statusMap = DOSSIER_STATUS, variant = "filled", style = {}, className }) {
  const cfg = statusMap[code] ?? { label: code ?? "—", bg: BRAND.background, color: BRAND.textMuted };
  const bg = variant === "tinted" ? hexToRgba(cfg.color, 0.18) : cfg.bg;

  if (className) {
    return <Box className={className} style={{ backgroundColor: bg, color: cfg.color, ...style }}>{cfg.label}</Box>;
  }

  return (
    <Box style={{
      display: "inline-flex", alignItems: "center", borderRadius: "20px",
      padding: variant === "tinted" ? "5px 14px" : "4px 12px",
      fontSize: variant === "tinted" ? "0.78rem" : "0.72rem",
      fontWeight: 700, fontFamily: "Inter",
      backgroundColor: bg, color: cfg.color, ...style,
    }}>
      {cfg.label}
    </Box>
  );
}
